export default __webpack_public_path__ + "static/media/aw.f68a3143.svg";